import { ChatActionNames } from "../constants/actionTypes"
import { IChatState } from "../interfaces/chat/whatsAppChat"

const init = (): IChatState => {
	return {} as IChatState
}

export const chatReducer = (state: IChatState = init(), action: any): IChatState => {
	switch (action.type) {
		case ChatActionNames.SET_IS_CHATSIDEBAROPEN:
			return {
				...state,
				isChatSidebarOpen: action.payload,
			}
		case ChatActionNames.SET_IS_FULLSCREEN_MODE:
			return {
				...state,
				isFullScreenMode: action.payload,
			}
		case ChatActionNames.SET_PATIENT_INFO:
			return {
				...state,
				patientInfo: action.payload,
			}
		case ChatActionNames.SET_NAMESPACE:
			return {
				...state,
				namespace: action.payload,
			}
		case ChatActionNames.SET_SHOW_ALL_GROUPS_CHAT_LIST:
			return {
				...state,
				showAllGroupsChatList: action.payload,
			}
		case ChatActionNames.SET_IS_CHAT_WINDOW_OPEN:
			return {
				...state,
				isChatWindowOpen: action.payload,
			}
		case ChatActionNames.SET_USER_UNREAD_MESSAGE_MAP:
			return {
				...state,
				userUnreadMessagesMap: action.payload,
			}
		case ChatActionNames.SET_TOTAL_UNREAD_COUNT:
			return {
				...state,
				totalUnreadCount: action.payload,
			}
		case ChatActionNames.SET_ALL_GROUPS_ADMIN_IDS:
			return {
				...state,
				allGroupsAdminIds: action.payload,
			}
		default:
			return state
	}
}
